export default ({ request }) => ({
  sampleStockSellListApi(data = {}) {
    return request({
      url: '/samplemanage/billStockSellMain/list',
      method: 'post',
      data
    })
  },
  sampleStockSellDetailApi(data = {}) {
    return request({
      url: '/samplemanage/billStockSellMain/detail',
      method: 'post',
      data
    })
  },
  sampleStockSellSaveApi(data = {}) {
    return request({
      url: '/samplemanage/billStockSellMain/save',
      method: 'post',
      data
    })
  },
  sampleStockSellDelApi(data = {}) {
    return request({
      url: '/samplemanage/billStockSellMain/del',
      method: 'post',
      data
    })
  },
  sampleStockSellAuditApi(data = {}) {
    return request({
      url: '/samplemanage/billStockSellMain/audit',
      method: 'post',
      data
    })
  }
})
